import Level1 from 'data/creatures/level-01';
import Level2 from 'data/creatures/level-02';
import Level3 from 'data/creatures/level-03';
import Level4 from 'data/creatures/level-04';
import Level5 from 'data/creatures/level-05';

export default [...Level1, ...Level2, ...Level3, ...Level4, ...Level5];
